// extracted by mini-css-extract-plugin
module.exports = {"root":"Paginator_root__TQ908","page":"Paginator_page__4nx9s","icon":"Paginator_icon__ZXirN","iconPrev":"Paginator_iconPrev__HnP_u","active":"Paginator_active__jyr1v"};